/**
 * @Injectable
 * All shared services
 *
 */

import { Injectable } from '@angular/core';


@Injectable()

export class HelperService {

  constructor() {}

  /**
   * Extend an object with another one
   *
   * @param		  {Object}       object to extend
   * @param		  {Object}       object to extend the first object with
   * @param		  {Boolean}      if existing key must be replaced
   * @return		{Object}       the first object extended with the second one
   */
  objectExtend(a: any, b: any, force?: boolean) {
    if(!force) force = true;
    for (let id in b) {
      if (force == true || !a.hasOwnProperty(id))
          a[id] = b[id];
    }
    return a;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/helper.service.ts